import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleRight, FaUserFriends, FaWallet } from "react-icons/fa";
import { FiLogOut, FiSettings } from "react-icons/fi";
import { MdDashboard, MdDeleteSweep, MdOutlineRequestQuote } from "react-icons/md";
import { HiOutlineMenu, HiMenu } from "react-icons/hi";
import HindLogo from "./logo.png";

const SideNavBar = ({
  setOpenPage,
  isCollapsed,
  toggleSidebar,
  setIsCollapsed,
}) => {
  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const menuSectionRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const UserName = localStorage.getItem("UserName");
  const UserAvatar = localStorage.getItem("UserAvatar");


  useEffect(() => {
    const handleMouseEnter = () => {
      if (isCollapsed) {
        setIsHovered(true);
        setIsCollapsed(false);
      }
    };

    const handleMouseLeave = () => {
      if (isHovered) {
        setIsHovered(false);
        setIsCollapsed(true);
      }
    };

    const menuSection = menuSectionRef.current;
    if (menuSection) {
      menuSection.addEventListener("mouseenter", handleMouseEnter);
      menuSection.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (menuSection) {
        menuSection.removeEventListener("mouseenter", handleMouseEnter);
        menuSection.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, [isCollapsed, isHovered, setIsCollapsed]);

  const handleLogout = () => {
    localStorage.removeItem("authToken"); 
    navigate("/login"); 
  };

  return (
    <div
      className={`fixed top-0 left-0 bg-gray-900 h-screen flex flex-col transition-all duration-300 ease-in-out z-50 ${
        isCollapsed && !isHovered ? "w-[3.6rem]" : "w-[13.9rem]"
      }`}
    >
      {/* Header */}
      <div
        className={`px-2 border-b py-3 border-gray-700 flex ${
          isCollapsed && !isHovered ? "justify-center" : "justify-between"
        } items-center`}
      >
        {(!isCollapsed || isHovered) && (
          <div className="flex items-center gap-4 overflow-hidden">
            <img
              src={HindLogo || "logo.png"}
              className="w-[500px] h-9 rounded-full product-upload-imageshrink-0"
              alt="Profile"
              
            />
            
          </div>
        )}
        <button
          onClick={toggleSidebar}
          className="text-white p-2 rounded-md hover:bg-gray-700 transition-colors shrink-0"
        >
          {isCollapsed && !isHovered ? (
            <HiMenu className="text-2xl" />
          ) : (
            <HiOutlineMenu className="text-2xl" />
          )}
        </button>
      </div>

      
      <div
        ref={menuSectionRef}
        className={`flex flex-col p-2 text-white overflow-y-auto h-[83vh] [&::-webkit-scrollbar]:w-2
        [&::-webkit-scrollbar-track]:bg-gray-900
        [&::-webkit-scrollbar-thumb]:bg-gray-900
        dark:[&::-webkit-scrollbar-track]:bg-gray-900
        dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500`}
      >
        {/* Dashboard */}
        {/* <Link
          to="/dashboard"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "dashboard" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Dashboard" : ""}
          onClick={() => {
            setActive("dashboard");
            setOpenPage("dashboard");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <MdDashboard className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Dashboard</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link> */}

        {/* User Details */}
        {/* <Link
          to="/user-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "user details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "user details" : ""}
          onClick={() => {
            setActive("user details");
            setOpenPage("user details");
            
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FaUserFriends className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">User Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link> */}

        {/* Product Details */}
        <Link
          to="/product-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "Product Details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Product Details" : ""}
          onClick={() => {
            setActive("Product Details");
            setOpenPage("Product Details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FaWallet className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Product Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        {/* Product Add */}
        <Link
          to="/product-add"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "product add" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Product Add" : ""}
          onClick={() => {
            setActive("product add");
            setOpenPage("product add");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <MdOutlineRequestQuote className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Add Product</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        {/* Category Details */}
        <Link
          to="/category-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "category details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "category details" : ""}
          onClick={() => {
            setActive("category details");
            setOpenPage("category details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Category Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>


        
        <Link
          to="/enquiry-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "enquiry details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "enquiry details" : ""}
          onClick={() => {
            setActive("enquiry details");
            setOpenPage("enquiry details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Enquiry Details</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        {/* Carousel Details */}
        <Link
          to="/carousel-details"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "carousel details" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "carousel details" : ""}
          onClick={() => {
            setActive("carousel details");
            setOpenPage("carousel details");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Carousel Image</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>


        <Link
          to="/background-image"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "Background Image" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Background Image" : ""}
          onClick={() => {
            setActive("Background Image");
            setOpenPage("Background Image");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Background Image</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        <Link
          to="/aboutus-page"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "AboutUs Page" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "AboutUs Page" : ""}
          onClick={() => {
            setActive("AboutUs Page");
            setOpenPage("AboutUs Page");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">AboutUs Page</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        <Link
          to="/aboutus-section"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "AboutUs Section" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "AboutUs Section" : ""}
          onClick={() => {
            setActive("AboutUs Section");
            setOpenPage("AboutUs Section");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">AboutUs Section</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>
        <Link
          to="/techinical-skills"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "Technical Skills" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Technical Skills" : ""}
          onClick={() => {
            setActive("Technical Skills");
            setOpenPage("Technical Skills");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Technical Skills</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        
        <Link
          to="/industrial-solutions"
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : "justify-between"
          } items-center p-2 rounded-[2px] mb-2 ${
            active === "Industrial Solutions" ? "bg-blue-800" : "bg-gray-800"
          } transition-colors`}
          title={isCollapsed && !isHovered ? "Industrial Solutions" : ""}
          onClick={() => {
            setActive("Industrial Solutions");
            setOpenPage("Industrial Solutions");
          }}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <FiSettings className="text-xl shrink-0" />
            {(!isCollapsed || isHovered) && (
              <p className="text-white text-[15px]">Industrial Solutions</p>
            )}
          </div>
          {(!isCollapsed || isHovered) && <FaAngleRight className="shrink-0" />}
        </Link>

        
        
      </div>

      
      <div className="mt-auto p-4 border-t border-gray-700">
        <div
          className={`flex ${
            isCollapsed && !isHovered ? "justify-center" : ""
          } items-center gap-3 text-white cursor-pointer hover:text-gray-300 transition-colors`}
          title={isCollapsed && !isHovered ? "Logout" : ""}
          onClick={handleLogout}
        >
          <FiLogOut className="shrink-0" />
          {(!isCollapsed || isHovered) && (
            <p className="whitespace-nowrap transition-all duration-300 ease-in-out">
              Logout
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideNavBar;
